var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react';
import { Translate } from "../../../../../../I18N";
import { Button } from "../../../../../Components/UI";
import { Sidepanel } from "../../../../../Components/UI/Sidepanel";
import { Icon } from "../../../../../../UI";
import { EntityFilter } from "./Filters";





const FilterSidePanel = ({ availableFilters }) => {
  const [open, setOpen] = useState(false);

  return (/*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx(Button, {
      className: "leading-4 flex gap-2 items-center text-gray-800",
      styling: "light",
      onClick: () => setOpen(true) }, void 0, /*#__PURE__*/

    _jsx(Icon, { icon: "filter" }), /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Filters")
    ), /*#__PURE__*/
    _jsx(Sidepanel, {
      withOverlay: true,
      isOpen: open,
      closeSidepanelFunction: () => {
        setOpen(false);
      },
      title: /*#__PURE__*/
      _jsx("span", { className: "text-base font-semibold text-gray-500 leading-6 uppercase" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Filters")
      ) }, void 0, /*#__PURE__*/


    _jsx(Sidepanel.Body, {}, void 0, /*#__PURE__*/
    _jsx(EntityFilter, { filterGroups: availableFilters, setFilters: () => {} })
    ), /*#__PURE__*/
    _jsx(Sidepanel.Footer, { className: "px-4 py-3 border-t" }, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2 justify-end" }, void 0, /*#__PURE__*/
    _jsx(Button, { size: "small", styling: "outline", onClick: () => console.log('clear all filters') }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Clear All")
    ), /*#__PURE__*/

    _jsx(Button, { size: "small", color: "success", onClick: () => console.log('apply filter') }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Apply")
    )
    )
    )
    )
    ));

};

export { FilterSidePanel };